// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryTextColor": "#4d4d4d",
	"primaryBlue": "#00aeef",
	"primaryBlueHover": "#009fdb",
	"primaryGreen": "#690",
	"primaryGreenHover": "#588400",
	"primaryGrey": "#4d4d4d",
	"primaryGreyHover": "#3f3f3f",
	"primarySand": "#f9edc9",
	"primarySandHover": "#eee2bd",
	"danger": "#c1272d",
	"dangerHover": "#940c12",
	"warning": "#efc700",
	"warningHover": "#d8b400",
	"success": "#7ab600",
	"successHover": "#73ab01",
	"info": "#00aeef",
	"infoHover": "#009fdb",
	"additionalGreen": "#22b573",
	"additionalGreenHover": "#1c9e64",
	"additionalBlue1": "#26c6da",
	"additionalBlue1Hover": "#25acbd",
	"additionalBlue2": "#0097a7",
	"additionalBlue2Hover": "#007f8c",
	"additionalBlue3": "#0071bc",
	"additionalBlue3Hover": "#0060a0",
	"additionalPurple": "#92278e",
	"additionalPurpleHover": "#741571",
	"additionalPink": "#ed1e79",
	"additionalPinkHover": "#b5006a",
	"additionalOrange1": "#f7931e",
	"additionalOrange1Hover": "#e4810d",
	"additionalOrange2": "#f15a24",
	"additionalOrange2Hover": "#de4813",
	"backgroundColor": "#f7f7f7",
	"grey1": "#f2f2f2",
	"grey2": "#e6e6e6",
	"grey3": "#c8c8c8",
	"grey4": "#9f9f9f",
	"grey5": "#8f8f8f",
	"grey6": "#5e5e5e",
	"grey7": "#4d4d4d",
	"grey8": "#3f3f3f",
	"white": "#fff",
	"realWorkShift": "rgba(0,174,239,.3)",
	"draftWorkShift": "rgba(243,232,178,.7)",
	"draftWorkShiftHover": "#f3e8b2",
	"workShiftAvailable": "repeating-linear-gradient(45deg, #ccdab2, #ccdab2, #becca4 10px, #becca4 1px)",
	"workShiftNotAvailable": "repeating-linear-gradient(45deg, #dddddd, #dddddd, #cfcfcf 10px, #cfcfcf 1px)",
	"stripedRed": "repeating-linear-gradient(45deg, white, #f2d5cd 1px, white 5px, #940c12 2px)",
	"stripedYellow": "repeating-linear-gradient(45deg, white, #ffd000 1px, white 5px, #f80 2px)",
	"unconfirmedTask": "#c1272d",
	"confirmedTask": "#efc700",
	"finishedTask": "#7ab600",
	"deletedTask": "#5e5e5e"
};
export default ___CSS_LOADER_EXPORT___;
